import { MethodsEnum } from "../enums/Methods.ts";
import handleService from "./apiService.ts";

const listarEmpresas = async () => {
  const result = await handleService({
    method: MethodsEnum.GET,
    endpoint: "/admin/empresas",
  });
  return result?.data || [];
};

const alterarLiberacao = async (empresaId: string, dataExpiracao: string) => {
  const result = await handleService({
    method: MethodsEnum.PATCH,
    endpoint: `/admin/empresas/${empresaId}/liberacao`,
    data: { dataExpiracao },
  });
  return result?.data;
};

const alterarPlano = async (empresaId: string, planoModeloId: string, ciclo: string) => {
  const result = await handleService({
    method: MethodsEnum.PATCH,
    endpoint: `/admin/empresas/${empresaId}/plano`,
    data: { planoModeloId, ciclo },
  });
  return result?.data;
};

const calcularImpactoExclusao = async (empresaId: string) => {
  const result = await handleService({
    method: MethodsEnum.GET,
    endpoint: `/admin/empresas/${empresaId}/impacto-exclusao`,
  });
  return result?.data;
};

const excluirEmpresa = async (empresaId: string) => {
  const result = await handleService({
    method: MethodsEnum.DELETE,
    endpoint: `/admin/empresas/${empresaId}`,
  });
  return result?.data;
};

const adminService = {
  listarEmpresas,
  alterarLiberacao,
  alterarPlano,
  calcularImpactoExclusao,
  excluirEmpresa,
};
export default adminService;
